import { ChannelItem } from ".";
import { ChannelDomain } from "../../../services/channels";
import messenger from "../../../assets/facebook_messenger.svg";
import { useAnalytics } from "../../../hooks/Analytics";

type MessengerProps = {
  channel?: ChannelDomain;
};

export function Messenger({ channel }: MessengerProps) {

  const send_analytics = useAnalytics();

  if (!channel || channel.type !== "messenger") {
    return <></>;
  }
  return (
    <ChannelItem
      icon={messenger}
      label="Messenger"
      onClick={() => {
        send_analytics("channel_selected", channel.id, channel.type);
        window.open(`${channel.link}`, "_blank");
      }}
    />
  );
}
